module.exports = __webpack_public_path__ + "37742a6754ae62f5a5dc9544b4e41870.svg";